import {makeStyles} from '@material-ui/core';
import {useCallback} from "react";

const useStyles = makeStyles(() => ({
  //score section in analysis
  icon: {
    width: 37,
    height: 37,
    marginBottom: 3
  },
  // overview icon
  icon0: {
    width: 42,
    height: 42,
    '@media screen and (max-width: 600px)': {
      width: 35,
      height: 35
    }
  },
  // header right scrore icon
  icon1: {
    width: 24,
    height: 24,
  },
  // pills icon
  icon2: {
    width: 20,
    height: 20,
  },
}));

function AnalysisScoreIcon(props: any) {

  const { color, type, size } = props;
  const classes = useStyles();
  const data = color?.trim()?.toLowerCase() + '-' + type;
  // const iconClass = size === 1 ? classes.icon1 : size === 2 ? classes.icon2 : size === 0 ? classes.icon0 : classes.icon;

  const iconClass = useCallback(() => {
    switch (size) {
      case 0:
        return classes.icon0;
      case 1:
        return classes.icon1;
      case 2:
        return classes.icon2;
      default:
        return classes.icon
    }
  }, [size, classes]);

  switch(data) {
    case 'red-immersion':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_immersion_red.svg`} alt={'score_icon'}/>;
    case 'gray-immersion':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_immersion_gray.svg`} alt={'score_icon'}/>;
    case 'green-immersion':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_immersion_green.svg`} alt={'score_icon'}/>;
    case 'blank-immersion':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_immersion_gray.svg`} alt={'score_icon'}/>;
    case 'red-safety':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_safety_red.svg`} alt={'score_icon'}/>;
    case 'gray-safety':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_safety_gray.svg`} alt={'score_icon'}/>;
    case 'green-safety':
      return <img className={iconClass()} src={`/assets/icons/liveanalysis/icon_safety_green.svg`} alt={'score_icon'}/>;
    default:
      return <></>;
  }
}
export default AnalysisScoreIcon;
